// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Storefront24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Storefront24: FC<Storefront24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M21.025 11.05V19c0 .55-.196 1.02-.587 1.413a1.926 1.926 0 0 1-1.413.587h-14c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 3.025 19v-7.95c-.383-.35-.68-.8-.887-1.35-.209-.55-.213-1.15-.013-1.8l1.05-3.4a2.21 2.21 0 0 1 .713-1.075A1.805 1.805 0 0 1 5.075 3h13.9c.45 0 .842.138 1.175.413.333.275.575.637.725 1.087l1.05 3.4c.2.65.196 1.242-.012 1.775a3.95 3.95 0 0 1-.888 1.375Zm-6.8-1.05c.45 0 .792-.154 1.025-.463.233-.308.325-.654.275-1.037l-.55-3.5h-1.95v3.7c0 .35.117.654.35.913.233.258.517.387.85.387Zm-4.5 0c.383 0 .696-.13.938-.387.241-.259.362-.563.362-.913V5h-1.95l-.55 3.5c-.067.4.02.75.263 1.05.241.3.554.45.937.45Zm-4.45 0c.3 0 .563-.108.788-.325.225-.217.362-.492.412-.825L7.025 5h-1.95l-1 3.35c-.1.333-.046.692.163 1.075.208.383.554.575 1.037.575Zm13.5 0c.483 0 .833-.192 1.05-.575.217-.383.267-.742.15-1.075L18.925 5h-1.9l.55 3.85c.05.333.188.608.413.825a1.1 1.1 0 0 0 .787.325Zm-13.75 9h14v-7.05a.605.605 0 0 1-.162.05h-.088c-.45 0-.846-.075-1.188-.225-.341-.15-.679-.392-1.012-.725-.3.3-.642.533-1.025.7-.383.167-.792.25-1.225.25-.45 0-.87-.083-1.262-.25a3.259 3.259 0 0 1-1.038-.7 3.05 3.05 0 0 1-.988.7 2.95 2.95 0 0 1-1.212.25 3.32 3.32 0 0 1-1.312-.25 3.258 3.258 0 0 1-1.038-.7c-.35.35-.696.596-1.037.737A3.01 3.01 0 0 1 5.275 12h-.112a.254.254 0 0 1-.138-.05V19Z" />
        </svg>
    );
};

export default Storefront24;
